import { render, staticRenderFns } from "./HaabRooms.vue?vue&type=template&id=5e58359d&scoped=true"
import script from "./HaabRooms.vue?vue&type=script&lang=js"
export * from "./HaabRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58359d",
  null
  
)

export default component.exports